// removed by extract-text-webpack-plugin
module.exports = {"bank-details":"bank-details__3isaj","card":"card__PpJ9b","flex-acc-item":"flex-acc-item__2BggI","font--12":"font--12__3pPAh","acc-clr-grey":"acc-clr-grey__e4ZE4","bank-doc":"bank-doc__1hh8G","file-input":"file-input__1-TRz","doc-preview":"doc-preview__1S4Ky","img-preview":"img-preview__3ITgP","clear-img":"clear-img__1UdFk","upload-form":"upload-form__1p3Au"};


//////////////////
// WEBPACK FOOTER
// ./styles/invest/pennyDropView.scss
// module id = 238
// module chunks = 68